import React from 'react';
import { DataGrid, GridToolbar  } from '@mui/x-data-grid';


const DataTable = ({
    token, 
    rows, 
    columns, 
    loading, 
    sx, 
    pageSize,
    onRowDoubleClick,
    checkboxSelection
}) => {

    return (
        <DataGrid
            rows={rows}
            columns={columns}
            loading={loading}
            sx={sx}
            checkboxSelection={checkboxSelection}
            pagination
            pageSize={pageSize}
            components={{ Toolbar: GridToolbar }}
            getRowHeight={() => 'auto'}
        />
    )
}

export default DataTable;